module.exports = __webpack_public_path__ + "img/Bilingüe.1391b57a.png";